import { apiClient, signApiRequest } from ".";
import { useMutation } from "@tanstack/react-query";
import { CustomerCredentials } from "../ui/customerDataStore";
import { captureException } from "@sentry/react";
interface Payload {
  signedData: object;
  email: string;
  validFrom: string;
  // Null until the customer picks a duration; the store starts it empty.
  validTo: string | null;
  credentials: CustomerCredentials;
}

export const createPOA = async ({
  signedData,
  email,
  validFrom,
  validTo,
  credentials,
}: Payload) => {
  const poaObject = {
    additionalData: {
      email,
      validFrom,
      validTo,
      fid: credentials.identityId,
    },
    ...signedData,
  };
  const signedRequest = await signApiRequest(
    "POST",
    `${import.meta.env.VITE_API_URL}/fmk/store`,
    credentials,
    { "content-type": "application/json" },
    poaObject,
  );

  const response = await apiClient(signedRequest);
  return response.data;
};

export const useCreatePOA = () =>
  useMutation({
    onError: (error) => {
      captureException(error, {
        tags: {
          operation: "createPOA",
          errorType: error.name || "UnknownError",
        },
        extra: {
          apiEndpoint: "/fmk/store",
        },
        level: "error",
      });
    },
    mutationFn: ({
      signedData,
      email,
      validFrom,
      validTo,
      credentials,
    }: Payload) =>
      createPOA({
        signedData,
        email,
        validFrom,
        validTo,
        credentials,
      }),
  });
